import NewsDetailContent from "../../modules/berita/component/NewsDetailContent";
import React from "react";

const NewsDetail: React.FC = () => {
  return (
    <div>
      <NewsDetailContent />
    </div>
  );
};

export default NewsDetail;
